import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { businessData } from '../mock';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Forside' },
    { path: '/om', label: 'Om Os' },
    { path: '/priser', label: 'Priser' },
    { path: '/anmeldelser', label: 'Anmeldelser' },
    { path: '/kontakt', label: 'Kontakt' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="header-classic">
      <div className="header-container">
        <Link to="/" className="logo-link">
          <h1 className="logo-text">Herrefrisør</h1>
          <p className="logo-subtitle">Nørrebro</p>
        </Link>

        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        {/* Phone CTA */}
        <a href={`tel:${businessData.phone}`} className="phone-cta">
          <Phone size={18} />
          <span>Ring til os</span>
        </a>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-button"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`mobile-nav-link ${isActive(item.path) ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              {item.label}
            </Link>
          ))}
          <a
            href={`tel:${businessData.phone}`}
            className="mobile-phone-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            <Phone size={18} />
            Ring til os
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;